<template>
  <div class=" is-fullwidth">
    <div class="is-pulled-right mb-2">
        <div class="columns">
          <div class="column"><button class="button " @click="updateExcludeSocks()" :class="{'is-success' : exclude_socks==1 || exclude_socks=='1'}" :disabled="loading==true">Exclude Socks</button></div>  
          
          <div class="column">
            <select name="location" v-model="location" class="input select">
              <option value="">Select Location ...</option>
              <option value="ireland">Ireland</option>
              <option value="offshore">Off-Shore</option>
              <option value="notset">Not Set Yet</option>
            </select>
          </div>
          <div class="column" v-if="location != '' && 1==2">
            <button class="button " @click="updateIncludeBlanks()" :class="{'is-success' : include_blanks==1 || include_blanks=='1'}" :disabled="loading==true">Include Not Set</button>
          </div>

          <div class="column"><input class=" input" type="date" v-model="start_date" placeholder="after due date" /></div>  
          <div class="column"><input class=" input" type="date" v-model="end_date" placeholder="up to due date" /></div>
            <div class="column"><input class="input " v-model="search" placeholder="search orders ..." :disabled="loading==true"/></div>
            <div class="column is-size-7">
              Displaying {{ filteredOrders.length }} order<span v-if="filteredOrders.length>1">s</span><br />
              Which is {{ garment_total_qty }} garments
            </div>
        </div>
        
        
    </div>

    <div v-if="location =='ireland' || location =='notset'">
      <hr style="clear:both" />
      <h4 class="title is-size-4">Summary</h4>
      <div class="columns">
        <div class="column" v-for="(count, status) in orderStatusCounts" :key="status">
          <div class="card">
            <div class="card-content">
              <div class="tag is-danger mb-2" v-if="status == 'With Artwork'">{{ status }}</div>
              <div class="tag is-info mb-2" v-if="status == 'Artwork Completed'">{{ status }}</div>
              <div class="tag is-warning mb-2" v-if="status == 'Printing Complete'">{{ status }}</div>
              <div class="tag is-link mb-2" v-if="status == 'Cutting Complete'">{{ status }}</div>
              <div class="tag is-success mb-2" v-if="status == 'In Makeup'">{{ status }}</div>
              <div class="tag  mb-2" v-if="status == 'Unknown'">{{ status }}</div>
              <br >
              {{ count.orders }} orders<br />
              {{ count.quantity }} garments<br />
            </div>
          </div>
        </div>

       
      </div>

      <hr />
      <h4 class="title is-size-4">Orders</h4>
    </div>
    
    <table class="table is-hoverable is-fullwidth is-size-7" id="orderstable">
    	<thead>
        <tr>
    		<th width="60">&nbsp;</th>
        <th>PO Number</th>
        <th>Rep Name</th>
   	 		<th>Customer</th>
        <th>Region</th>
          <th>Garment</th>
          <th>Range</th>
          <th>Design Name</th>
          <th width="80">Ordered</th>
          <th width="80">Delivery</th>
          <th>Qty</th>
          <th>Makeup</th>
          <th>Status</th>
        </tr>
    	</thead>
    	<tbody>
		    <tr v-if="loading === true">
                <td colspan="13" ><div class="notification is-info">Loading orders ...</div></td>
            </tr>
            <tr v-if="loading == false && filteredOrders.length == 0">
                <td colspan="13" ><div class="notification is-warning">There are no orders to show</div></td>
            </tr>
            
            <tr v-for="order in filteredOrders" v-bind:key="order.orderID">
         <td >
          <div class="tag is-success" v-if="order.fully_printed == 1">F/P</div>
            <div class="tag is-link" v-if="order.part_printed == 1">P/P</div>
            <div class="tag is-warning" v-if="order.cut_sew == 1">C/S</div>
                
              </td>
               <td > <a :href="ASP_URL + '/printorder.asp?txtPONumber=' + order.ponumber" target="_blank">{{order.ponumber}}</a></td>
          
          <td>{{order.firstname}} {{ order.surname }}</td>
          <td>{{order.clientname}}</td>
          <td>{{ displayClientLocationName(order.clientLocationID) }}</td>
          <td>{{order.garmentname}}</td>
          <td>{{order.range_name}}</td>
          <td>{{order.designname}}</td>
          <td>{{order.orderdate_excel}}</td>
          <td>{{order.deliverydate_excel}}</td>
          <td>{{ order.total_qty }}</td>
          <td>{{ order.makeup_location_name}}</td>
          <td>
            <div v-if="order.offshore == 1">
                <div class="tag is-danger" v-if="order.sent_offshore==0">Not Yet Sent</div>
                <div class="tag is-warning" v-if="order.sent_offshore==1 && order.in_production==0 ">Sent Offshore</div>
                <div class="tag is-success" v-if="order.in_production==1">In Production</div>
            </div>
            <div v-else>
              <div v-if="order.fully_printed == 1 || order.part_printed == 1">
                  <div class="tag is-danger" v-if="order.current_status=='With Artwork'">With Artwork</div>
                  <div class="tag is-info" v-if="order.current_status=='Artwork Completed'">Artwork Completed</div>
                  <div class="tag is-warning" v-if="order.current_status=='Printing Complete'">Printing Complete</div>
                  <div class="tag is-link" v-if="order.current_status=='Cutting Complete'">Cutting Complete</div>
                  <div class="tag is-success" v-if="order.current_status=='In Makeup'">In Makeup</div>
              </div>
              <div v-else>
                <div class="tag" >{{ order.current_status}}</div>
              </div>
              
            </div>
            
            
          </td>
          
          
              
			</tr>
    	</tbody>
      <tfoot>
        <tr>
          <td colspan="10">&nbsp;</td>
          <td>{{ garment_total_qty }}</td>
          <td colspan="2">&nbsp;</td>
        </tr>
      </tfoot>
    </table>

    <br />
    <button class="button is-success is-small" @click="exportXLS()" v-if="filteredOrders.length > 0 ">Export to Excel</button>
    
  </div>
</template>

<script>


import OrderService from '@/services/OrderService.js';
//import UtilityService from '@/services/UtilityService.js';

import OrderMixin from "@/mixins/OrderMixin.js";
import XLSX from 'xlsx';

export default {
  components: {
   	
  },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading: true,
      ASP_URL : process.env.VUE_APP_ASP_URL,
      ranges: [],
      makeuplocations: [],
      order_by: 'deliverydate DESC',
      location: '',
      search: '',
      end_date: '',
      start_date: '',
      exclude_socks: 0,
      include_blanks: 1,
      accessToken: '',
      makeup_location_id: '' // Always blank on this page
    }
  },
   methods: {
    exportXLS() {
      //var wb = XLSX.utils.table_to_book(document.getElementById('orderstable'), {sheet:"Sheet 1"});
      //XLSX.writeFile(wb, 'Open Orders Export.csv', {'bookType': 'csv'})

      var wb = XLSX.utils.book_new();
        wb.SheetNames.push("Open Orders");
        var ws1 = XLSX.utils.table_to_sheet(document.getElementById('orderstable')); 
        wb.Sheets["Open Orders"] = ws1;
      
        XLSX.writeFile(wb, 'Open Orders.xlsx');

    },
      async getOrders() {
        this.loading=true
        this.orders = []
        OrderService.getOpenOrders(this.accessToken, this.order_by, this.start_date, this.end_date,  this.exclude_socks, this.makeup_location_id, this.include_blanks, this.location)
        .then(
          (orders => {
            this.$set(this, "orders", orders);
            this.loading=false
          }).bind(this)
        );
      },
      getStartDate() {
            
            var d = new Date("2023-01-01");
            
            //d.setDate(d.getDate() - 90);
            return d.toISOString().slice(0,10);
             
      },
      getEndDate() {
            
            var d = new Date();
            
            d.setDate(d.getDate() + 7);
            return d.toISOString().slice(0,10);
             
    },
    updateExcludeSocks() {
      if(this.exclude_socks == 1 || this.exclude_socks == "1")
      {
        this.exclude_socks = 0
      }
      else{
        this.exclude_socks = 1
      }
    },
    updateIncludeBlanks() {
      if(this.include_blanks == 1 || this.include_blanks == "1")
      {
        this.include_blanks = 0
      }
      else{
        this.include_blanks = 1
      }
    }
    
   
    
  },
  computed : {
      filteredOrders: function () {
       
        let filteredOrders =  this.orders.filter(function() { // Rmeoved u from parameters
            //if(  u.in_progress == 0) 
           // {
              return 1
           // }
          })

          if(this.search != '' && this.search != null)
          {
            filteredOrders = filteredOrders.filter(row => row.range_name.toLowerCase().includes(this.search.toLowerCase()) || row.designname.toLowerCase().includes(this.search.toLowerCase()) || row.ponumber.toLowerCase().includes(this.search.toLowerCase()))
          }
          

          return filteredOrders
       
     },
     garment_total_qty: function() {
      let total = this.filteredOrders.reduce(function (previousValue, currentValue) {
          return previousValue + currentValue.total_qty;
        }, 0);

        return total;
     },
     orderStatusCounts() {
      // Initialize counts for each status
      const counts = {
        'With Artwork': { orders: 0, quantity: 0 },
        'Artwork Completed': { orders: 0, quantity: 0 },
        'Printing Complete': { orders: 0, quantity: 0 },
        'Cutting Complete': { orders: 0, quantity: 0 },
        'In Makeup': { orders: 0, quantity: 0 },
        'Unknown': { orders: 0, quantity: 0 },
      };

      // Loop through orders and update counts based on status
      this.filteredOrders.forEach(order => {
        const current_status = order.current_status;
        counts[current_status].orders++;
        counts[current_status].quantity += order.total_qty;
      });

      return counts;
    },
  },

  // Fetches posts when the component is created.
  mounted() {
    this.getAccessToken()
        .then(() => { 
           this.getOrders();
           //this.getMakeupLocations();
        });
  },
 
  created() {

    //if (localStorage.open_orders_makeup_location_id) {
    //  this.makeup_location_id = localStorage.open_orders_makeup_location_id;
    //}
    //else{
    //  this.makeup_location_id = ''
    //}

    if (localStorage.open_orders_location) {
      this.location = localStorage.open_orders_location;
    }
    else{
      this.location = ''
    }

    if (localStorage.open_orders_search) {
      this.search = localStorage.open_orders_search;
    }
    else{
      this.search = ''
    }

    if (localStorage.open_orders_start_date) {
      this.start_date = localStorage.open_orders_start_date;
    }
    else{
      this.start_date = this.getStartDate()
    }

    if (localStorage.open_orders_end_date) {
      this.end_date = localStorage.open_orders_end_date;
    }
    else{
      this.end_date = this.getEndDate()
    }

    if (localStorage.open_orders_exclude_socks) {
      this.exclude_socks = localStorage.open_orders_exclude_socks;
    }
    else{
      this.exclude_socks = 0
    }

    if (localStorage.open_orders_include_blanks) {
      this.include_blanks = localStorage.open_orders_include_blanks;
    }
    else{
      this.include_blanks = 0
    }
      
  },
  watch: {
    /*makeup_location_id: function () {
      localStorage.open_orders_makeup_location_id = this.makeup_location_id

      if(this.makeup_location_id == '')
      {
        this.include_blanks = 1
      }

      if(this.accessToken != "")
      {
        this.getOrders()
      }
    },*/
    location: function () {
      localStorage.open_orders_location = this.location

      //if(this.location == '')
      //{
      //  this.include_blanks = 1
      //}

      if(this.accessToken != "")
      {
        this.getOrders()
      }
    },
    search: function () {
      localStorage.open_orders_search = this.search
      
    },
    start_date: function () {
      localStorage.open_orders_start_date = this.start_date
      if(this.accessToken != "")
      {
        this.getOrders()
      }
    },
    end_date: function () {
      localStorage.open_orders_end_date = this.end_date
      if(this.accessToken != "")
      {
        this.getOrders()
      }
    },
    exclude_socks: function () {
      localStorage.open_orders_exclude_socks = this.exclude_socks
      if(this.accessToken != "")
      {
        this.getOrders()
      }
    },
    include_blanks: function () {
      localStorage.open_orders_include_blanks = this.include_blanks
      if(this.accessToken != "")
      {
        this.getOrders()
      }
    },
  }
}


</script>

